module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['change-section', _vm.subclass]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_c('div', {
    staticClass: "col-l-12 col-m-12 col-s-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.blockdata.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-l-3 col-m-4 col-s-12"
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.elements), function(element, index) {
    return _c('li', {
      key: index,
      class: ['item', {
        active: _vm.slug(element.name) === _vm.currentItem
      }],
      on: {
        "click": function($event) {
          _vm.switchPage(_vm.slug(element.name), _vm.pageSlug)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(element.name))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-l-6 col-m-8 col-s-12"
  }, _vm._l((_vm.elements), function(element, index) {
    return (_vm.slug(element.name) === _vm.currentItem) ? _c('div', {
      key: index,
      staticClass: "content"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(element.content)
      }
    }), _vm._v(" "), _vm._l((element.downloads), function(download, downloadindex) {
      return _c('div', {
        key: downloadindex
      }, [(download.file.url) ? _c('a', {
        staticClass: "btn default",
        attrs: {
          "href": download.file.url,
          "target": "_blank",
          "download": ""
        }
      }, [_vm._v(_vm._s(download.file.title))]) : _vm._e()])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-l-3 col-m-8 col-m-offset-4 col-s-12"
  }, _vm._l((_vm.elements), function(element, index) {
    return (_vm.slug(element.name) === _vm.currentItem) ? _c('div', {
      key: index,
      staticClass: "more-info",
      domProps: {
        "innerHTML": _vm._s(element.moreinfo)
      }
    }) : _vm._e()
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1aad47a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangeSection.vue
// module id = 362
// module chunks = 0